import { render, staticRenderFns } from "./EditOrCreate.vue?vue&type=template&id=f9d8efa6&scoped=true&"
import script from "./EditOrCreate.vue?vue&type=script&lang=js&"
export * from "./EditOrCreate.vue?vue&type=script&lang=js&"
import style0 from "./EditOrCreate.vue?vue&type=style&index=0&id=f9d8efa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d8efa6",
  null
  
)

export default component.exports